export default function RealityCheck() {
  const painPoints = [
    {
      icon: 'ri-calendar-close-line',
      text: 'Pas de RDV réguliers malgré un site en ligne',
    },
    {
      icon: 'ri-user-unfollow-line',
      text: 'Peu de demandes entrantes ou contacts qualifiés',
    },
    {
      icon: 'ri-chat-smile-2-line',
      text: 'Business qui repose encore sur le bouche à oreille',
    },
    {
      icon: 'ri-eye-off-line',
      text: 'Site invisible sur Google et les réseaux sociaux',
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-gray-50 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Left — Text */}
          <div>
            <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
              <i className="ri-error-warning-line text-sm"></i>
              Le constat
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-[2.75rem] font-bold text-gray-900 leading-tight mb-6">
              La réalité&nbsp;: votre site n'est pas aussi efficace que prévu
            </h2>

            <p className="text-lg text-gray-500 leading-relaxed mb-8">
              Vous avez un site propre, pro… Mais <span className="font-semibold text-gray-700">peu de demandes</span>, pas de RDV réguliers et un business qui dépend encore du <span className="font-semibold text-gray-700">bouche à oreille</span>.
            </p>

            <p className="text-gray-500 leading-relaxed">
              Ce n'est pas un problème de crédibilité. C'est un problème de <span className="font-semibold text-orange-600">système d'acquisition</span>. Un site seul ne génère rien — il faut un moteur derrière.
            </p>
          </div>

          {/* Right — Pain points */}
          <div className="grid sm:grid-cols-2 gap-4">
            {painPoints.map((point, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 border border-gray-100 flex items-start gap-4 hover:-translate-y-1 transition-transform duration-300"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-orange-50 flex-shrink-0">
                  <i className={`${point.icon} text-xl text-orange-500`}></i>
                </div>
                <p className="text-sm font-medium text-gray-700 leading-snug pt-1">
                  {point.text}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
